// External libraries
import cookie from 'js-cookie';
import { get } from 'lodash';
import React from 'react';
import styled, { withTheme } from 'styled-components';

// Zocdoc libraries
import { FontFamily } from '@zocdoc-frontend-common/styles-typography';
import { Link } from '@zocdoc-frontend-common/components-link';

import { ALREADY_READ_TERMS_COOKIE } from './constants';

const bannerTheme = props => props.theme.components.PrivacyUpdateBanner;

const BannerContainer = styled.div`
    background-color: ${props => bannerTheme(props).bgColor};
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    height: 48px;
    box-sizing: border-box;
    padding: 10px;
    transition: height 0.6s ease-in-out, padding 0.6s ease-in-out;

    &.hidden {
        height: 0px;
        padding: 0px;
    }
`;

const BannerContents = styled.div`
    color: ${props => bannerTheme(props).textColor};
    font-family: ${FontFamily.SharpSansSemibold};
    text-align: center;
    opacity: 1;
    transition: opacity 0.3s ease-in-out;

    &.hidden {
        opacity: 0;
    }
`;

const BannerMessage = styled.span`
    &::after {
        content: ' ';
    }
`;

export const PrivacyUpdateBannerView = withTheme(
    ({ hidden, onClickLink, theme }) => {
        const uri = get(
            theme,
            'components.PrivacyUpdateBanner.privacyLink.uri'
        );
        const PrivacyUpdateLinkText = 'Take a look';
        const PrivacyUpdateMessage = 'We’ve updated our Privacy policy.';
        const hiddenClassName = hidden ? 'hidden' : '';

        return (
            <BannerContainer
                className={hiddenClassName}
                data-test="privacy-update-banner"
            >
                <BannerContents
                    className={hiddenClassName}
                    data-test="privacy-update-banner-contents"
                >
                    <BannerMessage>{PrivacyUpdateMessage}</BannerMessage>
                    <Link
                        data-test="privacy-update-banner-link"
                        href={uri}
                        onClick={onClickLink}
                        target="_blank"
                    >
                        {PrivacyUpdateLinkText}
                    </Link>
                </BannerContents>
            </BannerContainer>
        );
    }
);

class PrivacyUpdateBanner extends React.PureComponent {
    state = { hidden: true };

    componentDidMount() {
        const currentCookieValue = cookie.get(ALREADY_READ_TERMS_COOKIE.Key);
        const isAlreadyRead =
            currentCookieValue === ALREADY_READ_TERMS_COOKIE.Value;

        // eslint-disable-next-line react/no-did-mount-set-state
        this.setState({ hidden: isAlreadyRead });
    }

    onClickLink = () => {
        cookie.set(
            ALREADY_READ_TERMS_COOKIE.Key,
            ALREADY_READ_TERMS_COOKIE.Value,
            { expires: ALREADY_READ_TERMS_COOKIE.ExpirationDays }
        );

        this.setState({ hidden: true });
    };

    render() {
        return (
            <PrivacyUpdateBannerView
                hidden={this.state.hidden}
                onClickLink={this.onClickLink}
            />
        );
    }
}

export default PrivacyUpdateBanner;
